import React from "react";
import KamranRazviPhoto from "../Assets/images/kamran-razvi.jpg"; // Replace with your actual photo path

function HorizontalCard() {
  return (
    <div className="mt-32 max-w-6xl mx-auto px-6">
      <div className="group relative bg-white border border-gray-100 rounded-[3rem] shadow-2xl shadow-blue-500/5 overflow-hidden transition-all duration-500 hover:shadow-blue-500/10 hover:-translate-y-1">
        <div className="flex flex-col md:flex-row items-center justify-between p-12 md:p-16 gap-12">
          {/* Content section */}
          <div className="flex-1 text-center md:text-left">
            <div className="inline-flex items-center gap-2 px-4 py-2 bg-blue-50 text-blue-600 rounded-full text-sm font-bold mb-6 border border-blue-100">
              <span>📅</span> Consultation
            </div>
            <h2 className="text-3xl md:text-4xl font-black text-black mb-4 tracking-tight">
              Book a 1 on 1 call
            </h2>
            <p className="text-gray-500 text-lg font-medium mb-8 max-w-lg">
              Wanna chat about your specific use case? Let's jump on a 15-minute call and help you win!
            </p>
            <a
              href="https://calendly.com/kamranrazvi/braccet-1-on-1-call"
              target="_blank"
              rel="noopener noreferrer"
              className="inline-block px-10 py-5 text-white bg-blue-600 rounded-full font-bold shadow-xl transition-all duration-300 hover:scale-105 active:scale-95 hover:bg-blue-700"
            >
              Book Now
            </a>
          </div>

          {/* Photo and name section */}
          <div className="flex flex-col items-center gap-4 bg-gray-50/50 p-8 rounded-[2.5rem] border border-gray-100 min-w-[280px]">
            <div className="relative">
              <div className="absolute inset-0 bg-blue-500 blur-2xl opacity-20 group-hover:opacity-40 transition-opacity" />
              <img
                src={KamranRazviPhoto}
                alt="Kamran Razvi"
                className="relative rounded-[2rem] h-32 w-32 object-cover shadow-2xl border-4 border-white"
              />
            </div>
            <div className="text-center">
              <p className="text-xl font-black text-black">Kamran Razvi</p>
              <p className="text-gray-500 font-bold text-sm uppercase tracking-widest">Founder at Braccet</p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default HorizontalCard;
